import {
  Box,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  Icon,
} from "@mui/material";
import React, { useState } from "react";
import { icons, images } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { useNavigate } from "react-router-dom";

const sectionData = [
  {
    id: 1,
    title: "Fibre Broadband",
    price: "£34.99",
    bgColor: "linear-gradient(to right, #f2e0b2, #feda7c)",
    rightImg: images.fiberImg,
    options: [
      {
        id: 1,
        image: icons.circleWorldIcon,
        icon: "language",
        title: "Unlimited internet",
      },
      {
        id: 2,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Line rental included",
      },
      {
        id: 3,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Plug and play router",
      },
      {
        id: 4,
        image: icons.circlePowerIcon,
        icon: "bolt",
        title: "Download speed up to 40 Mbps",
      },
    ],
    showMore: false,
  },
  {
    id: 2,
    title: "Superfast Fibre Broadband",
    price: "£35.99",
    bgColor: "linear-gradient(to right, #ffda7a, #ededed)",
    rightImg: images.superFastFiberCutImg,
    options: [
      {
        id: 1,
        image: icons.circleWorldIcon,
        icon: "language",
        title: "Unlimited internet",
      },
      {
        id: 2,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Line rental included",
      },
      {
        id: 3,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Plug and play router",
      },
      {
        id: 4,
        image: icons.circlePowerIcon,
        icon: "bolt",
        title: "Download speed up to 80 Mbps",
      },
    ],
    showMore: false,
  },
];

const BroadbandOnlySection = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [broadbandData, setBroadbandData] = useState(sectionData);

  const handleShowMore = (inddddd) => {
    let tempArrr = [...broadbandData];
    tempArrr[inddddd].showMore = !tempArrr[inddddd].showMore;
    setBroadbandData(tempArrr);
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
        textAlign: "center",
        marginTop: "20px",
        paddingBottom: "30px",
      }}
      id="broadband-only"
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "22px", sm: "35px", md: "50px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          marginBottom: "30px",
          fontFamily: "Raleway",
        }}
      >
        Broadband Only
      </Typography>

      <Grid container spacing={3}>
        {broadbandData.map((itemmmm, inddd) => {
          return (
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  background: itemmmm.bgColor,
                  padding: {
                    xs:
                      inddd == 0 ? "15px 24px 24px 18px" : "15px 0px 24px 18px",
                    sm: "15px 0px 24px 44px",
                  },
                  borderRadius: "20px",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    background: allColors.royalOrange,
                    borderRadius: "20px",
                    padding: "5px",
                    display: { xs: "block", sm: "none" },
                    textAlign: "center",
                    width: inddd == 0 ? "80%" : "90%",
                    margin: "10px auto 12px",
                    marginRight: inddd == 1 ? "24px" : "auto",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Raleway",
                      fontSize: { xs: "20px", md: "28px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                    }}
                  >
                    {itemmmm.title}{" "}
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={4}
                  mt={0.5}
                  display={{ xs: "none", sm: "block" }}
                >
                  <Grid item xs={12} sm={10}>
                    <Box
                      sx={{
                        background: allColors.royalOrange,
                        borderRadius: "10px",
                        padding: "5px 0",
                        width: inddd == 0 ? "65%" : "85%",
                      }}
                    >
                      <Typography
                        component={"span"}
                        sx={{
                          fontFamily: "Raleway",
                          fontSize: { xs: "20px", md: "28px" },
                          color: allColors.jetBlack,
                          fontWeight: "300",
                        }}
                      >
                        {itemmmm.title}{" "}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={3}
                  sx={{ position: "relative" }}
                  alignItems={{ xs: "center", sm: "flex-end" }}
                >
                  <Grid item xs={6.5} md={6}>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Squad-Regular",
                          fontSize: { xs: "40px", md: "50px" },
                          color: allColors.jetBlack,
                          fontWeight: "700",
                          textAlign: "left",
                          marginTop: "10px",
                          marginLeft: { xs: "20px", sm: 0 },
                        }}
                      >
                        {itemmmm.price}
                        <span
                          style={{
                            fontSize: isSmallScreen ? "10px" : "14px",
                          }}
                        >
                          p/m
                        </span>
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        {itemmmm.options.map((optiionn) => {
                          return (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                marginLeft: { xs: "5px", sm: 0 },
                              }}
                            >
                              {optiionn.icon == "phone_in_talk" ? (
                                <img
                                  src={optiionn.image}
                                  alt={optiionn.image}
                                  style={{
                                    width: isSmallScreen ? "35px" : "45px",
                                    height: isSmallScreen ? "35px" : "45px",
                                    marginRight: "10px",
                                  }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    background: allColors.jetBlack,
                                    borderRadius: "50%",
                                    padding: { xs: "5px", sm: "10px" },
                                    marginRight: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Icon
                                    sx={{
                                      color: inddd == 0 ? "#f2e0b2" : "#ffda7a",
                                    }}
                                  >
                                    {optiionn.icon}
                                  </Icon>
                                </Box>
                              )}
                              <Typography
                                sx={{
                                  fontSize: { xs: "12px", sm: "14px" },
                                  color: allColors.jetBlack,
                                  fontWeight: "400",
                                  textAlign: "left",
                                }}
                              >
                                {optiionn.title}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={5.5} md={6}>
                    <img
                      src={
                        isSmallScreen && inddd == 0
                          ? images.fibreNewImg
                          : itemmmm.rightImg
                      }
                      style={{
                        width: isSmallScreen
                          ? "100%"
                          : inddd == 0
                          ? "70%"
                          : "100%",
                        height: "100%",
                        marginTop: isSmallScreen ? "30px" : "0px",
                      }}
                    />
                  </Grid>
                </Grid>

                {itemmmm.showMore && (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    Download speed of up to {inddd == 0 ? "40 Mbps" : "80 Mbps"}
                    . Upload speed of up to {inddd == 0 ? "10 Mbps" : "20 Mbps"}
                    . Speeds dependent on availability. Tariff upgrade may be
                    required. £30 router configuration and delivery cost
                    applies.{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/voip-terms-&-conditions")}
                    >
                      Full T&Cs
                    </span>
                    .
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  position: "relative",
                  marginTop: "-22px",
                }}
              >
                {!itemmmm.showMore ? (
                  <GlobalButton
                    handleClickBtn={() => handleShowMore(inddd)}
                    title={"Show more"}
                    style={{
                      background: allColors.white,
                      color: allColors.jetBlack,
                      border: `1px solid ${allColors.pastelGray}`,
                      borderRadius: "10px",
                      fontSize: "12px",
                      padding: { xs: "10px 40px", sm: "10px 20px" },
                    }}
                  />
                ) : (
                  <a href={"#contact-us"}>
                    <GlobalButton
                      handleClickBtn={() => handleShowMore(inddd)}
                      title={"Switch today"}
                      style={{
                        background: allColors.blueCrayola,
                        color: allColors.white,
                        border: `1px solid ${allColors.blueCrayola}`,
                        borderRadius: "10px",
                        fontSize: "12px",
                        padding: { xs: "10px 40px", sm: "10px 20px" },
                      }}
                    />
                  </a>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default BroadbandOnlySection;
